import {ReactNode} from "react";

export enum ReactNodeCategory {
    NONE,
    PRIMITIVE_VALUE,
    JSX_ELEMENT
}

// This isn't a 100% hermetic solution, but should be sufficient for the CardLayout to make correct rendering decisions about its children
export function categorizeReactNode(elem: ReactNode): ReactNodeCategory {
    switch (typeof elem) {
        case "undefined":
            return ReactNodeCategory.NONE;
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "bigint":
            return ReactNodeCategory.PRIMITIVE_VALUE;
        default:
            return ReactNodeCategory.JSX_ELEMENT;
    }
}